<template>
  <v-container fluid pa-0>
    <!-- MESSAGES -->
    <v-dialog
      v-model="showMessage"
      max-width="390"
      persistent
    >
      <v-card width="390">
        <v-card-title primary-title>
          <div>
            <div class="headline">Misión Creada Correctamente</div>
            <br />
            <v-icon size="42px" color="white">check_circle</v-icon>
            <br />
            <br />
            <p>
              La información de las misiones ha cambiado, por eso se ha iniciado un proceso de carga automática de las misiones.
            </p>
          </div>
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            @click="showMessage = false"
          >
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- FORM CREATE BASE MISSION -->
    <v-dialog v-model="showForm" width="465" persistent>
      <base-missions-form
        v-if="showForm"
        :selections="selections"
        :templatesUp="templatesUp.length > 0 ? templatesUp[0] : selections[0]"
        @cancel="cancelCreateBaseMission"
        @reload="reloadMissionsTemplates"
      />
    </v-dialog>
    <!-- CONTENT -->
    <v-layout column>
      <v-card>
        <v-toolbar class="pr-2" color="grey darken-3" flat>
          <v-toolbar-title>Misiones Base</v-toolbar-title>
        </v-toolbar>
        <!-- LOADING MISSIONS BASE TREE -->
        <v-flex v-if="$loading.isLoading('fetchMissionsTemplates')" pa-3>
          <h3>Cargando listado de Misiones...</h3>
          <v-progress-circular color="primary" indeterminate class="ma-3" />
        </v-flex>
        <v-flex v-else d-inline-flex py-3>
          <v-flex px-2>
            <v-treeview
              v-bind="selected"
              item-key="id"
              item-text="name"
              activatable
              active-class="primary"
              :items="missionsTemplates"
              :active.sync="itemFromMissionBaseSelected"
              :return-object="true"
            ></v-treeview>
          </v-flex>
          <v-divider vertical></v-divider>
          <v-flex px-3>
            <v-flex v-if="selections.length === 0">
              <h3>Seleccionar una misión</h3>
              <v-flex py-5 class="text-xs-center">
                <v-avatar
                  size="100px"
                  color="grey darken-4">
                  <v-icon color="grey darken-3" size="80px">flag</v-icon>
                </v-avatar>
              </v-flex>
            </v-flex>
            <v-flex v-else>
              <h3>
                {{
                  selections.length === 1 ?
                    'Misión Seleccionada' :
                    'Misiones Seleccionadas'
                }}
              </h3>
              <v-flex d-flex>
                <v-flex style="width:300px;" pr-3>
                  <!-- INFO MISSION -->
                  <v-flex>
                    <h4>
                      <span>Nombre:</span> {{ selections[0].name }}
                    </h4>
                    <div v-if="selections[0].description !== null">
                      <span>Descripción:</span> {{ selections[0].description }}
                    </div>
                    <div v-if="selections[0].userAgencyId !== null">
                      <!-- {{
                        agenciesMap.get(agenciesMap.get(selections[0].userAgencyId).superParentId).name
                      }}
                      <br /> -->
                      <span>Agencia:</span> {{ agenciesMap.get(selections[0].userAgencyId).name }}
                      <br />
                      <div v-if="selections[0].agencyId !== null">
                        <span>Vehículos del grupo/agencia:</span>
                        {{ 
                          selections[0].agencyId !== null
                            ? agenciesMap.get(selections[0].agencyId).name
                            : agenciesMap.get(selections[0].userAgencyId).name
                        }}
                      </div>
                    </div>
                    <div v-if="selections[0].disabledAgencies !== null">
                      <span>Excepto los vehículos del grupo/agencia:</span> {{ agenciesMap.get(Number(selections[0].disabledAgencies)).name }}
                    </div>
                  </v-flex>
                  <!-- BUTTON CREATE BASE MISSION -->
                  <v-flex
                    v-if="selectionsCheck"
                    py-2 pr-2
                  >
                    <v-divider class="my-2"></v-divider>
                    <v-btn
                      color="primary"
                      block
                      @click="showCreateBaseMissionForm"
                    >
                      Crear Misión Base
                    </v-btn>
                  </v-flex>
                  <v-flex v-else class="message-info" d-inline-flex align-center px-2 mt-2>
                    <v-icon size="32px" color="white">info</v-icon>
                    <p class="pl-2 pt-3">
                      Por las características de esta misión no es posible crear misiones base que dependan de esta.
                    </p>
                  </v-flex>
                </v-flex>
                <v-divider vertical></v-divider>
                <!-- ZONES LIST -->
                <v-flex v-if="selections[0].where !== null" style="width:300px;" pl-3>
                  <h3>Zonas</h3>
                  <ul>
                    <li v-for="(where, index) in whereData(selections[0].where)" :key="index">
                      {{ where.text }}
                    </li>
                  </ul>
                </v-flex>
              </v-flex>
            </v-flex>
          </v-flex>
        </v-flex>
      </v-card>
    </v-layout>
  </v-container>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'

  import BaseMissionsForm from '../BaseMissionsForm'

  export default {
    name: 'base-missions',
    components: {
      BaseMissionsForm
    },
    data() {
      return {
        itemFromMissionBaseSelected: [],
        selections: [],
        showForm: false,
        matchUp: false,
        parentIdNext: '0',
        templateUpIn: null,
        templatesUp: [],
        showMessage: false
      }
    },
    computed: {
      ...mapGetters(['missionsTemplates', 'agenciesMap']),
      ...mapGetters({
        fullZoneMaps: 'filters/fullZoneMaps'
      }),
      selected() {
        this.selections = []
        this.templatesUp = []
        this.matchUp = false

        if (!this.itemFromMissionBaseSelected.length) return undefined
        const obj = this.itemFromMissionBaseSelected[0]
        console.log('SELECTED', obj)

        const mission = {
          children: obj.children,
          agencyId: obj.agencyId,
          parentId: obj.parentId,
          disabledAgencies: obj.disabledAgencies,
          baseMissionId: obj.id,
          name: obj.name,
          description: obj.description,
          where: obj.where,
          userAgencyId: obj.userAgencyId,
          type: obj.type
        }
        this.selections.push(mission)
        // this.selections = this.selections.filter(item => item.where !== null)
        this.parentIdNext = obj.parentId
        if (obj.parentId !== null) {
          while (this.parentIdNext !== null) {
            // console.log('WHILE: ', this.parentIdNext)
            this.recursiveSearchUp(this.missionsTemplates, this.parentIdNext)
            this.matchUp = false
          }
        }
        console.log('TEMPLATE FULL', this.templatesUp)
        return obj
      },
      selectionsCheck() {
        let whereTemp = []
        if (this.selections[0].where !== null) {
          whereTemp = [...this.selections[0].where]
          // Checking the special case of San Cristóbal and San Javier
          // polygons
          let indexSC = null
          let indexSJ = null
          const indexes = []
          const whereTempChecked = []
          for (let index = 0; index < whereTemp.length; index++) {
            const element = whereTemp[index]
            if (element === 33647 || element === 34665) { // San Cristóbal
              if (indexSC === null) {
                const newIndexIn = whereTempChecked.push([element])
                indexSC = newIndexIn - 1
              } else {
                whereTempChecked[indexSC] = [...whereTempChecked[indexSC], element]
              }
              indexes.push(index)
            } else if (element === 33643 || element === 34664) { // San Javier
              if (indexSJ === null) {
                const newIndexIn = whereTempChecked.push([element])
                indexSJ = newIndexIn - 1
              } else {
                whereTempChecked[indexSJ] = [...whereTempChecked[indexSJ], element]
              }
              indexes.push(index)
            }
          }
          for (let index = indexes.length - 1; index >= 0; index--) {
            whereTemp.splice(indexes[index], 1)
          }
          // Set the selected polygons of the mission to the state
          // that is related with the v-model of the WHERE
          whereTemp = [...whereTemp, ...whereTempChecked]
        } else whereTemp = null
        console.log('whereTemp', whereTemp)
        let result = whereTemp === null || whereTemp.length <= 1
        return result
      }
    },
    methods: {
      ...mapActions(['fetchMissionsTemplates']),
      whereData(where) {
        if (where === null) return []
        const items = []
        where.forEach(element => {
          const obj = {
            text: this.fullZoneMaps.get(element),
            value: element
          }
          items.push(obj)
        })
        const whereSort = items.sort(function(a, b) {
          var textA = a.text
          var textB = b.text
          return (textA < textB) ? -1 : (textA > textB) ? 1 : 0
        })

        let counterSC = 0
        let counterSJ = 0
        const whereSortChecked = []
        for (let index = 0; index < whereSort.length; index++) {
          const element = whereSort[index]
          if (element.text === 'San Cristóbal A' || element.text === 'San Cristóbal B') {
            if (counterSC === 0) {
              whereSortChecked.push({
                text: 'San Cristóbal',
                value: [element.value]
              })
            } else {
              const indexIn = whereSortChecked.findIndex(item => item.text === 'San Cristóbal')
              if (indexIn !== -1) whereSortChecked[indexIn].value.push(element.value)
            }
            counterSC++
          } else if (element.text === 'San Javier A' || element.text === 'San Javier B') {
            if (counterSJ === 0) {
              whereSortChecked.push({
                text: 'San Javier',
                value: [element.value]
              })
            } else {
              const indexIn = whereSortChecked.findIndex(item => item.text === 'San Javier')
              if (indexIn !== -1) whereSortChecked[indexIn].value.push(element.value)
            }
            counterSJ++
          } else whereSortChecked.push(element)
        }
        return whereSortChecked
      },
      showCreateBaseMissionForm() {
        this.showForm = true
      },
      cancelCreateBaseMission() {
        this.showForm = false
      },
      recursiveSearchUp(obj, id) {
        for (const children in obj) {
          if (this.matchUp) break

          if (typeof obj[children] === 'object' && obj[children] !== null) {
            if (obj[children].id === id) {
              this.templateUpIn = obj[children]
              if (this.templateUpIn.parentId === null) this.templatesUp.push(this.templateUpIn)
              this.matchUp = true
              this.parentIdNext = this.templateUpIn.parentId
              break
            } else {
              this.recursiveSearchUp(obj[children], id)
            }
          }
        }
      },
      reloadMissionsTemplates() {
        this.fetchMissionsTemplates()
        this.showMessage = true
      }
    },
    created() {
      if (this.missionsTemplates.length === 0) this.fetchMissionsTemplates()
    }
  }
</script>

<style lang="scss" scoped>
span {
  color: #9E9E9E;
  font-weight: 500;
}

.message-info {
  background-color: #212121;
  border-radius: 3px;
}
</style>


// WEBPACK FOOTER //
// src/components/Missions/BaseMissions.vue